module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/template-compiler?{"id":"data-v-50780142"}!D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 526
// module chunks = 0